import { isObject } from 'highcharts';
import type { ZodIssue } from 'zod';
import type { FormError } from './form';

/**
 * @deprecated Remove this once Supply point panel is rewritten into Antd
 * https://enmontech.atlassian.net/browse/ENMON-2528
 */
export const isZodIssue = (value: unknown): boolean => {
  if (!isObject(value)) return false;
  const { path, code } = value as ZodIssue;

  return (
    Array.isArray(path) &&
    path.every(pathValue => typeof pathValue === 'string' || typeof pathValue === 'number') &&
    typeof code === 'string'
  );
};

/**
 * @deprecated Remove this once Supply point panel is rewritten into Antd
 * https://enmontech.atlassian.net/browse/ENMON-2528
 */
export const mapZodIssueToFormErrorItem = (issue: Readonly<ZodIssue>): Readonly<FormError> => {
  const { code, path, message, ...rest } = issue;
  return {
    path,
    message,
    type: code,
    context: rest,
  };
};
